<template>
    <Page404 v-if="show404" />
</template>

<script>
import BackendProvider from '../../business/services/BackendProvider'
import UIUtils from '../../business/utils/UIUtils'
import Page404 from './Page404.vue'

export default {
    name: 'EmrTreatmentLink',
    components: { Page404 },
    data() {
        return {
            show404: false
        }
    },
    mounted() {
        UIUtils.showLoadingMask()
        this.redirectToTreatmentLink()
    },
    methods: {
        async redirectToTreatmentLink() {
            if (!this.$route.query) {
                return this.show404Page()
            }
            const { treatmentExternalId, patientExternalId } = this.$route.query
            if (!treatmentExternalId || !patientExternalId) {
                return this.show404Page()
            }
            try {
                const link = await BackendProvider.getTreatmentLink({
                    treatmentExternalId,
                    patientExternalId
                })
                if (link) {
                    window.location.href = link
                    return
                }
                this.show404Page()
            } catch (e) {
                this.show404Page()
            }
        },
        show404Page() {
            UIUtils.hideLoadingMask()
            this.show404 = true
        }
    }
}
</script>
